import { render, staticRenderFns } from "./ScrollSettings.vue?vue&type=template&id=5d3eb084&scoped=true"
import script from "./ScrollSettings.vue?vue&type=script&lang=js"
export * from "./ScrollSettings.vue?vue&type=script&lang=js"
import style0 from "./ScrollSettings.vue?vue&type=style&index=0&id=5d3eb084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3eb084",
  null
  
)

export default component.exports